module.exports = __webpack_public_path__ + "img/kma_gallery2.b752f6b0.jpg";